// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1V_iF","right":"Footer_right__1weIH","buttons":"Footer_buttons__2GAIX"};